module.exports = __webpack_public_path__ + "img/user.9325c61c.png";